export default "__VITE_ASSET__f8af8636__"